<template>
    <div>
        <today-write-link v-for="writeLayout in writeLayouts" :key="`today${writeLayout}`"
                          :writeLayout="writeLayout" :todayData="todayData" :categoryData="categoryData"></today-write-link>
    </div>
</template>

<script>
import alertMixins from "@/mixins/alertMixins";
import todayUtil from "@/components/today/todayUtil";
import util from "@/mixins/util";
import EventBus from "@/mixins/event-bus";
import DeleteClass from "@/mixins/deleteClass";
import TodayWriteLink from "@/components/today/TodayWriteLink";

export default {
    name: "TodayWriteComponent",
    mixins: [alertMixins, todayUtil],
    components: {TodayWriteLink,},
    inject: [],
    provide() {
        return {
            deleteTodayData: this.runDeleteConfirm
        }
    },
    props: {
        todayType: {},
        todayKey: {default: 0},
    },
    data() {
        return {
            getFunc: '',
            detailApiParamSet: {},
            writeFunc: '',
            writeLayouts: [],
            writeApiParamSet: {},
            todayData: {},
            isRunning: false,
            parsingData: {},
            directUrl: '',
            directType: '',
            writeSuccessType: 1,
            writeFailTypes: {},
            writeFailMsg: '',
            CommentCount: 0,
            isCategory: false,
            getCategoryFunc: '',
            categoryData: {},

            deleteFunc: '',
            deleteApiParamsSet: {},
            deleteSuccessType: 1,
            deleteFailTypes: {},
            deleteKeyName: '',

            DeleteClass: null,
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.initFilterConfig();
        if (this.todayKey === 0) {
            this.initTemplateConfig();
        } else {
            this.getToday();
            this.getCategory();
        }
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        initTemplateConfig() {
            let config = this.returnTodayConfig(this.todayType);
            this.writeLayouts = config.writeLayouts;
        },
        initFilterConfig() {
            let config = this.returnTodayConfig(this.todayType);
            this.getFunc = config.getFunc;
            this.writeFunc = config.writeFunc;
            this.writeApiParamSet = config.writeApiParamSet;
            this.writeSuccessType = config.writeSuccessType;
            this.writeFailTypes = config.writeFailTypes;
            this.writeFailMsg = config.writeFailMsg;

            this.parsingData = config.parsingData;
            this.detailApiParamSet = config.detailApiParamSet;
            this.keyName = config.keyName;
            this.directUrl = config.directUrl;
            this.directType = config.directType;
            this.isCategory = config.isCategory;
            this.getCategoryFunc = config.getCategoryFunc;

            this.deleteFunc = config.deleteFunc;
            this.deleteApiParamsSet = config.deleteApiParamsSet;
            this.deleteSuccessType = config.deleteSuccessType;
            this.deleteFailTypes = config.deleteFailTypes;

            this.newDeleteClass();
        },
        getToday() {
            let params = Object.assign({}, this.detailApiParamSet, this.defaultFilter);
            params.id = this.todayKey;
            EventBus.$emit('changeLoading', true);
            try {
                this.$api.$today[this.getFunc](params).then(res => res.Data.Result).then(res => {
                    if (res.Info.Type !== 1 || util.isEmpty(res.List)) {
                        this.errorAlert('데이터를 불러올 수 없습니다.');
                        this.$router.back();
                        return false;
                    }
                    this.todayData = res.List[0];
                    EventBus.$emit('changeLoading', false);
                    this.initTemplateConfig();
                })
            } catch (e) {
                console.log((e));
                EventBus.$emit('changeLoading', false);
            }
        },
        getCategory() {
            let params = {};
            try {
                this.$api.$today[this.getCategoryFunc](params).then(res => res.Data.Result).then(res => {
                    if (!util.isEmpty(res.List)) {
                        this.categoryData = res.List;
                    }
                })
            } catch (e) {
                console.log(e);
            }
        },
        newDeleteClass() {
            if (!util.isEmpty(this.deleteFunc)) {
                let deleteOptions = {
                    func: this.$api.$today[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.keyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                }
                this.DeleteClass = new DeleteClass(deleteOptions);
            }
        },
        runDeleteConfirm(key) {
            this.openDeleteConfirm({
                confirm: (value) => {
                    this.runDelete(key, value);
                },
                cancel: () => {
                }
            })
        },
        runDelete(key, value) {
            EventBus.$emit('apiLoading', true);
            this.DeleteClass.runDelete(key, {mb_password: value,})
        },
        deleteAfterFunc() {
            EventBus.$emit('changeLoading', false)
            this.createAlert({
                content: '삭제가 완료되었습니다.',
                hide: () => {
                    this.$router.back();
                }
            })
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
